import { useContext, useEffect, useState, useCallback, useRef } from "react";
// BrowserRouter
import { Link, useHistory } from "react-router-dom";
import "./App.css";
import GlobalContext from "GlobalContext";
import QlikObject from "components/QlikObject";
import ConnectionLostModal from "components/ConnectionLostModal";
import ControlSideBar from "components/ControlSideBar";
import BookmarkListMenu from "components/BookmarkListMenu";
import UserLoginLink from "components/UserLogin";
import UserLogoutLink from "components/UserLogout";
import Footer from "components/Footer";
import useAuthenticatedUser from "hooks/useAuthenticatedUser"; 
import GoogleAnalytics from "components/GoogleAnalytics";
import Routes from "./Routes";
import MainMenu from "./MainMenu";
import SideBar from "./SideBar";
import applyURLSelections from "utils/selectionsSupport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from '@fortawesome/free-solid-svg-icons'; // Import the specific icon

function App() {
  // const [qlikLib, setQlik] = useState(null);
  const { qlik, app /*translations*/ } = useContext(GlobalContext);
  const [sessionClosed, setSessionClosed] = useState(false);
  const [siderBarOpened, setSideBarOpened] = useState(false);
  const authUser = useAuthenticatedUser();
  const history = useHistory();
  // const [isAppReady, setAppReady] = useState(false);
  const [menuLayout, setMenuLayout] = useState({
    HeaderTitle: "Автобусні перевезення",
    FeedbackText: "Зворотній зв'язок",
    appDisclaimer:"На етапі пілотного проєкту результати аналізу не є офіційною статистикою і можуть бути не точними.",
    MenuItem1: "Показники",
    MenuItem2: "Навантаження на МАПП",
    MenuItem3: "Детальна інформація + карта",
    MenuItem4: "Аналіз виконаних автобусних перевезень",
    MenuItem5: "Ліцензії на перевезення",
    ConnectionLostTitle: "Підключення втрачено",
    ConnectionLostMessage:
      "Ваше підключення до Qlik Sense сервера втрачено, оновіть сторінку для продовження роботи.",
    ConnectionLostRefresh: "Оновити",
    Filters: "Всі фiльтри",
    Login: " ",
    isAppReady: false, // Add `isAppReady` to the initial state
  });


/*   useEffect(() => {
    // Update `isAppReady` in `menuLayout` whenever it changes
    setMenuLayout((prevLayout) => ({
      ...prevLayout,
      isAppReady,
    }));
  }, [isAppReady]); */

  const sidebarOverlayEl = useRef(null);

  const menuHandler = useCallback((e) => {
    e && e.preventDefault();
    if (document.body.classList.contains("sidebar-open")) {
      document.body.classList.remove("sidebar-open");
      document.body.classList.add("sidebar-closed");
    } else {
      document.body.classList.remove("sidebar-closed");
      document.body.classList.add("sidebar-open");
    } 
    document.body.classList.toggle("sidebar-collapse");
  }, []);

  const closeMenuHandler = useCallback(
    (e) => {
      if (sidebarOverlayEl.current) {
        console.log("sidebarOverlayEl :  " + sidebarOverlayEl.current);
        const overlayVisible =
          window.getComputedStyle(sidebarOverlayEl.current).display !== "none";
        if (overlayVisible) {
          // close menu when navigate (!)
          menuHandler(e);
        }
      }
    },
    [menuHandler]
  );

  useEffect(() => {
    // applyURLSelections here to be able to navigate bookmark's page
    (async () => {
      await applyURLSelections(app, history);
    })();    
    qlik.on("error", function (error) {
      // console.error(error.method);
      if (
        error.method === "OnSessionClosed" ||
        error.method === "OnSessionTimedOut" ||
        error.message === "ProxyError.OnSessionTimedOut" ||
        error.message === "ProxyError.OnSessionClosed"
      ) {
        setSessionClosed(true);
      }
    });
  }, [qlik, app, history]);

  useEffect(() => {
    let menuItems;
    const createGeneric = async () => {
      menuItems = app.createGenericObject(
        {
          HeaderTitle: {
            qStringExpression: "='$(mshp_app_title)'",
          },
          ExportChartFootnote: {
            qStringExpression: "=''",
          },
          KPIsAsOfDate: {
            qStringExpression: "=$(T(mshp_LastReloadTime)) & ' ' & ( last_load_time )",
          },
          MenuItem1: {
            qStringExpression: "='$(mshp_home_page_title)'",
          },
          MenuItem2: {
            qStringExpression: "='$(mshp_destination_page_title)'",
          },
          MenuItem3: {
            qStringExpression: "='$(mshp_details_page_title)'",
          },
          MenuItem4: {
            qStringExpression: "='$(mshp_completedRoutes_page_title)'",
          },
          MenuItem5: {
            qStringExpression: "='$(mshp_licensing_page_title)'",
          },
          ConnectionLostTitle: {
            qStringExpression: "='$(mshp_connectionLost_title)'",
          },
          ConnectionLostMessage: {
            qStringExpression: "='$(mshp_connectionLost_description)'",
          },
          ConnectionLostRefresh: {
            qStringExpression: "='$(mshp_connectionLost_refresh)'",
          },
          Filters: {
            qStringExpression: "='$(mshp_filters_title)'",
          },
/*           Login: {
            qStringExpression: "='Увійти'",
          }, */
          exportText: {
            qStringExpression: "='$(mshp_export_started_title)'",
          },
          exportCompletedText: {
            qStringExpression: "='$(mshp_export_finished_title)'",
          },
          closeBtnText: {
            qStringExpression: "='$(mshp_export_close_title)'",
          },
/*           containerTabSelector: {
            qStringExpression: "=$(=$(scrSelOneRoute))",
          },
          containerTabSelectorProjects: {
            qStringExpression: "=btnChoice_2",
          },
          containerTabSelectorGeo: {
            qStringExpression: "=vGeoInvestBtn",
          }, */
          tourParamsNext: {
            qStringExpression: "='$(mshp_tour_param_next_title)'",
          },
          tourParamsPrev: {
            qStringExpression: "='$(mshp_tour_param_previous_title)'",
          },
          tourParamsDone: {
            qStringExpression: "='$(mshp_tour_param_finished_title)'",
          },
          tourParamsSkip: {
            qStringExpression: "='$(mshp_tour_param_skip_title)'",
          },
          tourGlobalNavbar: {
            qStringExpression: "='$(mshp_tour_global_navbar_description)'",
          },
          tourGlobalNavbarTitle: {
            qStringExpression: "='$(mshp_tour_global_navbar_title)'",
          },
          tourGlobalNavbarHomePage: {
            qStringExpression: "='$(mshp_tour_home_page_description)'",
          },
          tourGlobalNavbarHomePageTitle: {
            qStringExpression: "='$(mshp_home_page_title)'",
          },
          tourGlobalNavbarDestinations: {
            qStringExpression: "='$(mshp_tour_destination_page_description)'",
          },
          tourGlobalNavbarDestinationsTitle: {
            qStringExpression: "='$(mshp_destination_page_title)'",
          },
          tourGlobalNavbarDetails: {
            qStringExpression: "='$(mshp_details_page_title)'",
          },
          tourGlobalNavbarDetailsTitle: {
            qStringExpression: "='$(mshp_tour_details_page_description)'",
          },
          tourGlobalNavbarCompletedRoutes: {
            qStringExpression: "='$(mshp_tour_completedRoutes_page_description)'",
          },
          tourGlobalNavbarCompletedRoutesTitle: {
            qStringExpression: "='$(mshp_completedRoutes_page_title)'",
          },
          tourGlobalNavbarLicensing: {
            qStringExpression: "='$(mshp_tour_licensing_page_description)'",
          },
          tourGlobalNavbarLicensingTitle: {
            qStringExpression: "='$(mshp_licensing_page_title)'",
          },
          tourGlobalCurrentSelections: {
            qStringExpression: "='$(mshp_tour_currentSelections_description)'",
          },
          tourGlobalCurrentSelectionsTitle: {
            qStringExpression: "='$(mshp_tour_currentSelections_title)'",
          },
          tourGlobalCurrentSelectionsNavigationButtons: {
            qStringExpression: "='$(mshp_tour_currentSelections_buttons_description)'",
          },
          tourGlobalCurrentSelectionsNavigationButtonsTitle: {
            qStringExpression: "='$(mshp_tour_currentSelections_buttons_title)'",
          },
          tourGlobalCurrentSelectionsActiveFilters: {
            qStringExpression: "='$(mshp_tour_currentSelections_activeSelections_description)'",
          },
          tourGlobalCurrentSelectionsActiveFiltersTitle: {
            qStringExpression: "='$(mshp_tour_currentSelections_activeSelections_title)'",
          },
          tourGlobalAllFilters: {
            qStringExpression: "='$(mshp_tour_filterPane_description)'",
          },
          tourGlobalAllFiltersTitle: {
            qStringExpression: "='$(mshp_tour_filterPane_title)'",
          },
          tourHomePage: {
            qStringExpression: "='$(mshp_tour_home_description)'",
          },
          tourHomePageTitle: {
            qStringExpression: "='$(mshp_home_page_intro_title)'",
          },
          tourHomeKPIRow: {
            qStringExpression: "='$(mshp_home_page_kpi_row_description)'",
          },
          tourHomeKPIRowTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_row_title)'",
          },
          tourHomeKPISingle: {
            qStringExpression: "='$(mshp_home_page_kpi_single_description)'",
          },
          tourHomeKPISingleTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_single_title)'",
          },
          tourHomeKPISingleNoOfRoutes: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_routes_description)'",
          },
          tourHomeKPISingleNoOfRoutesTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_routes_title)'",
          },
          tourHomeKPISingleNoOfRoutesSwitch: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_routes_description)'",
          },
          tourHomeKPISingleNoOfRoutesSwitchTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_routes_title)'",
          },
          tourHomeKPISingleNoOfFlightsTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_flights_title)'",
          },
          tourHomeKPISingleNoOfFlights: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_flights_description)'",
          },
          tourHomeKPISingleNoOfFlightsSwitch: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_flights_switch_description)'",
          },
          tourHomeKPISingleNoOfFlightsSwitchTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_single_no_of_flights_switch_title)'",
          },
/*           tourHomeFiltersSidebar: {
            qStringExpression: "=$(T(msh_tour_home_filterpane_side))",
          }, */
          tourHomeBarchart: {
            qStringExpression: "='$(mshp_home_page_chart_description)'",
          },
          tourHomeBarchartTitle: {
            qStringExpression: "='$(mshp_home_page_chart_title)'",
          },
          tourHomeBarchartSelection: {
            qStringExpression: "='$(mshp_home_page_chart_selector_description)'",
          },
          tourHomeBarchartSelectionTitle: {
            qStringExpression: "='$(mshp_home_page_chart_selector_title)'",
          },
          tourHomeContainer: {
            qStringExpression: "='$(mshp_home_page_container_description)",
          },
          tourHomeContainerTitle: {
            qStringExpression: "='$(mshp_home_page_container_title)'",
          },
          tourParamsOf: {
            qStringExpression: "='$(mshp_tour_param_of_title)'",
          },
          tourParamsTourStartButton: {
            qStringExpression: "='$(mshp_tour_param_button_tittle)'",
          },
          tourCompletedRoutesSingleKPINoOfFlights: {
            qStringExpression: "='$(mshp_completedRoutes_page_kpi_single_no_of_flights_description)'",
          },
          tourCompletedRoutesSingleKPINoOfFlightsTitle: {
            qStringExpression: "='$(mshp_completedRoutes_page_kpi_single_no_of_flights_title)'",
          },
          tourCompletedRoutesKPIRow: {
            qStringExpression: "='$(mshp_completedRoutes_page_kpi_row_description)'",
          },
          tourCompletedRoutesKPIRowTitle: {
            qStringExpression: "='$(mshp_home_page_kpi_row_title)'",
          },
          tourCompletedRoutesTable: {
            qStringExpression: "='$(mshp_completedRoutes_page_table_selector_description)'",
          },
          tourCompletedRoutesTableTitle: {
            qStringExpression: "='$(mshp_completedRoutes_page_table_selector_title)'",
          },
          tourCompletedRoutesSankey: {
            qStringExpression: "='$(mshp_completedRoutes_page_sankey_description)'",
          },
          tourCompletedRoutesSankeyTitle: {
            qStringExpression: "='$(mshp_completedRoutes_page_sankey_title)'",
          }

        },
/*         (reply) => {
          setMenuLayout({ ...reply });
          setAppReady(true); // Notify that the app is ready
        } */
          (reply) => {
            setMenuLayout((prevLayout) => ({
              ...prevLayout,
              ...reply,
              isAppReady: true
            }));
            // setAppReady(true);
          }
      );
    };
    createGeneric();
    return () => {
      if (menuItems && menuItems.qInfo)
        app.destroySessionObject(menuItems.qInfo.qId);
    };
  }, [app]);

  const sideBarOpenHandler = (e) => {
    e.preventDefault();
    setSideBarOpened(!siderBarOpened);
  };

  // console.log('menuLayout = ',menuLayout);
  return (
    <>
      {sessionClosed && (
        <ConnectionLostModal
          title={menuLayout.ConnectionLostTitle}
          text={menuLayout.ConnectionLostMessage}
          refreshText={menuLayout.ConnectionLostRefresh}
        />
      )}
      {/* <Router> */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link pushmenu-btn"
                data-widget="pushmenu"
                href="/"
                role="button"
                onClick={menuHandler}
              >
                <i className="lui-icon lui-icon--menu"></i>
              </a>
            </li>
          </ul>
          <div className="form-inline">
            <h4 className="mb-0 prz-sale">{menuLayout.HeaderTitle}</h4>
          </div>

          <ul className="navbar-nav ml-auto d-flex align-items-center">

            {/* <li className="nav-item jumpappfeedback">
              <a
                className="nav-link nav-link-black"
                href="https://docs.google.com/forms/d/e/1FAIpQLSfABoOsWy4wdAZ1m3wiCWwMAc12aDy3VFo3jIwxCcqvwRE89g/viewform"
                target="_blank"
                rel="noopener noreferrer"
                >
                📈 {menuLayout.RequestAnalyticsText}
              </a>
            </li>

            <li className="nav-item jumpappfeedback-mobile">
              <a
                className="nav-link nav-link-black"
                href="https://docs.google.com/forms/d/e/1FAIpQLSfABoOsWy4wdAZ1m3wiCWwMAc12aDy3VFo3jIwxCcqvwRE89g/viewform"
                target="_blank"
                rel="noopener noreferrer"
                >
                📈
              </a>
            </li> */}

{/*             <li className="nav-item jumpappfeedback">
              <a
                className="nav-link nav-link-black"
                // href="https://google.com.ua/"
                href={menuLayout.FeedbackURL}
                target="_blank"
                rel="noopener noreferrer"
                >
                🔗 {menuLayout.FeedbackText}
              </a>
            </li>

            <li className="nav-item jumpappfeedback-mobile">
              <a
                className="nav-link nav-link-black"
                href={menuLayout.FeedbackURL}
                target="_blank"
                rel="noopener noreferrer"
                >
                🔗
              </a>
            </li> */}

{/*             <li className="nav-item lang-btns">
              <QlikObject id="7252e2f6-cf00-477a-b9a7-e17d82102ae5" height="29px" showLoader={false} />
            </li>
            <li className="nav-item w-lang-mobile lang-btns-mobile">
              <QlikObject id="d74900ec-bf2b-4d6d-a776-aba5bacb21bf" height="29px" showLoader={false} />
            </li>    */}
   
         
            <li className="nav-item">
              <a
                className={`nav-link tour-global-filterpane-dropdown ${
                  siderBarOpened ? "active filterpane-active" : "filterpane-inactive"
                }`}
                href="/"
                role="button"
                onClick={sideBarOpenHandler}
              >
                {siderBarOpened ? (
                  <FontAwesomeIcon icon={faXmark} className="lui-icon" />
                ) : (
                  <i className="lui-icon lui-icon--filterpane" />
                )}
                <span className={siderBarOpened ? "filters-txt-active" : "filters-txt"} justified-text>
                  {siderBarOpened ? " | " + menuLayout.closeBtnText : menuLayout.Filters}
                </span>
                {/* fas fa-th-large */}
              </a>
            </li>

{/*             <li className="nav-item appHelp">
                <QlikObject
                  id="LTMED"
                  height="29px"
                  showLoader={false}
                />           
            </li> */}



{/*             {!authUser.User || authUser.isAnonymous || sessionClosed ?
              <>
                <UserLoginLink loginText={menuLayout.Login} />
              </>
              :
              <>
                <BookmarkListMenu
                  app={app}
                  showBookmarkDetails={false}
                  user={authUser}
                />

                <UserLogoutLink user={authUser} />
              </>
              } */}

          </ul>
        </nav>

        <div className="main-header current-selections tour-global-current-selections">
          <QlikObject id="CurrentSelections" height="38px" showLoader={false} />
        </div>

        {/* sidebar-light-primary | sidebar-dark-secondary */}
        <aside className="main-sidebar sidebar-light-primary elevation-1 ">
          <Link to="/" className="brand-link">
            <img
              src={`${process.env.PUBLIC_URL}logo-dark-miu-ukr-2.svg`}
              alt="Logo"
              className="brand-image"
            />
            {/* <span className="brand-text font-weight-light">Dashboard</span> */}
          </Link>

          <div className="sidebar tour-global-sidebar">
            <nav className="pt-2">
              <ul
                className="nav nav-pills nav-sidebar flex-column nav-child-indent"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <MainMenu
                  menuLayout={menuLayout}
                  closeMenuHandler={closeMenuHandler}
                />
              </ul>
            </nav>
{/*               <div className="as-of-date-disclaimer">
                <p>
                {menuLayout.KPIsAsOfDate}
                </p>
              </div> */}
          </div>
        </aside>

        <div className="content-wrapper">
          <GoogleAnalytics id="X">
            <Routes menuLayout={menuLayout} />
          </GoogleAnalytics>
        </div>

        {/* Right sidebar */}
        <ControlSideBar opened={siderBarOpened}>
          {siderBarOpened && <SideBar />}
        </ControlSideBar>

        {/* <footer className="main-footer"></footer> */}
      {/* </Router> */}
      <Footer />
      <div id="sidebar-overlay" ref={sidebarOverlayEl} onClick={menuHandler} />
    </>
  );
}

export default App;
